import { getStore } from '~/mobx/AppStore';

const getCandidatePhoto = () => {
    const { candidateStore } = getStore();
    if (!candidateStore.previewCandidatePhoto) {
        return candidateStore.candidatePhoto;
    }

    const previewUrl = URL.createObjectURL(candidateStore.previewCandidatePhoto);

    return {
        name: candidateStore.previewCandidatePhoto?.name ?? '',
        url: previewUrl,
    };
};

export default getCandidatePhoto;
